import {
  section,
  container,
  image,
  content,
  titleText,
  descriptionText,
  button,
} from './SobreTrabalho.styles';
import ProfileDesktop from '../../assets/profiledesktop.jpg';
import ProfileMobile from '../../assets/profilemobile.jpg';
import { FaWhatsapp } from 'react-icons/fa';
import { useEffect, useState } from 'react';
import { handleOpenLink } from '../../utils/common';

export default function SobreTrabalho() {
  const [isMobile, setIsMobile] = useState(null);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const checkScreen = () => setIsMobile(window.innerWidth < 768);
    checkScreen();
    window.addEventListener('resize', checkScreen);
    return () => window.removeEventListener('resize', checkScreen);
  }, []);

  return (
    <section className={section}>
      <div className={container}>
        {isMobile && <p className={titleText}>Excelência e Profissionalismo</p>}
        <img
          src={isMobile ? ProfileMobile : ProfileDesktop}
          alt='SobreTrabalho'
          className={image}
        />
        <div className={content}>
          {!isMobile && (
            <p className={titleText}>Excelência e Profissionalismo</p>
          )}
          <p className={descriptionText}>
            Ao escolher a Dra. Bruna Fais, você conta com uma profissional
            qualificada e dedicada, que prioriza o bem-estar e a satisfação de
            cada paciente
          </p>
          <p className={descriptionText}>
            Com atendimento personalizado e atenção aos detalhes, ela busca
            constantemente inovações para oferecer os melhores resultados em
            todos os procedimentos.
          </p>
          <button
            onClick={() =>
              handleOpenLink(
                'https://wa.me/+5519996268961?text=Ol%C3%A1,%20venho%20atrav%C3%A9s%20do%20site%20e%20gostaria%20de%20agendar%20uma%20Avalia%C3%A7%C3%A3o%20em%20Harmoniza%C3%A7%C3%A3o%20Orofacial%20com%20a%C2%A0Dra%C2%A0Bruna%C2%A0Fais.',
                'agendar_consulta_click',
                'Agendar consulta',
                window.location.pathname
              )
            }
            className={button}
          >
            <FaWhatsapp />
            Agendar consulta
          </button>
        </div>
      </div>
    </section>
  );
}
